import { Component, Input, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/api/cart.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { Router } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { WinService } from 'src/app/services/win.service';
import { environment as env } from './../../../../environments/environment';
// import { FbpixelService } from 'src/app/services/api/fbpixel.service';
import { FilesService, UseUploadedFiles } from 'src/app/services/api/files.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-artwork',
  templateUrl: './artwork.component.html',
  styleUrls: ['./artwork.component.scss']
})
export class ArtworkComponent implements OnInit {

	onClose: any;

	/* start part is when the upload attachment was already checked out */
	artworkOnly:any = false;
	quoteId:any = false;
	quoteItemId:any = false;
	order: any = null;
	/* end part is when the upload attachment was already checked out */

	product: any = null;
	selectedQty: any = null;
	selectedQtyPrice: any = null;
	selectedChild: any = null;
	customOption: any = null;
	instructions: any = '';
	config: any = null;

	@Input() awupload: any = 'start';

	/* upload start */
	file: any = null;
	uploadProgress: any = '';
	ref: any = '';
	task: any = '';
	downloadURL: any = '';
	fileName: any = null;

	/** 
	 * since Feb 12 2026 multi layout is supported 
	 * but only for 10 pcs (sample) order
	 * this will hold the files that will be uploaded 
	 */
	files: any = [];

	isAddingItemToCart:boolean = false;

	useUploadedFiles:UseUploadedFiles = new UseUploadedFiles();

	multiLayoutNote: string = `For orders consisting of multiple layouts with a total of 10 pieces, the distribution of quantities per layout will be determined at our discretion.<br/>Customers cannot request a specific allocation of the 10 pieces across the layouts`;

	constructor(
		public firebaseService: FirebaseService,
		public cartService: CartService,
		public lang: LangService,
		public router: Router,
		public winService: WinService,
		/** this is used by UseUploadedFiles */
		public filesService: FilesService,
		public sessionService: SessionService
	) { }

	ngOnInit() {
		this.isAddingItemToCart = false;
		this.cartService.get('/rest/entrelable/V1/lns-orderattachment/config').subscribe(config => {
			this.config = config[0];
		});

		this.cartService.getCartId().then(quote_id => {

		});

		this.uploadedFiles.setMultiLayout();
	}

	/**
	 * close login modal
	 */
	closeModal(data:any = {}){
		this.onClose(data);
	}

	/**
	 * switch the modal to upload form
	 */
	uploadArtWorkForm(awu: string = ''){
		if(awu == "layout_catalog"){
			this.uploadedFiles.getUploadedFiles();
		}
		this.awupload = awu;
	}

	/**
	 * this method will call the custom API for adding the
	 * item in the cart. the custom API do the function to 
	 * save the previouse API requests into a single request
	 */
	startAddToCartV2() {
		if(!this.artworkOnly){
			let canAddToCard = false;
			let formData = new FormData();
			if(this.uploadedFiles.canSelectectMultiLayout){
				/** this is for multi file upload */
				if(this.files.length){
					this.files.forEach(f => {
						formData.append('attachments[]', f.file);
					});
				}

				if(this.uploadedFiles._selectedItems.length){
					let itemIds = [];
					this.uploadedFiles._selectedItems.forEach(item => {
						itemIds.push(item.id);
					});
					formData.append('lns_orderattachment_files_ids', itemIds.join(','));
				}

				if((this.files.length + this.uploadedFiles._selectedItems.length) <= this.uploadedFiles.maxLayout){
					canAddToCard = true;
				}
				else {
					this.cartService.toastService.add('You can only add up to '+this.uploadedFiles.maxLayout+' layout/s.', 'danger');
				}
			}
			else {
				/** this is for single file upload */
				if(this.file){
					let file = this.file.target.files[0];
					formData.append('attachment', file);
				}

				if(this.uploadedFiles.selectedItem.id){
					formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
				}

				canAddToCard = true;
			}

			if(canAddToCard){
				this.isAddingItemToCart = true;
				this.awupload = 'addingtocart';
				
				this.cartService.getCartId().then(quote_id => {
					if(quote_id){
						let jsonData = this.getJsonData(quote_id);
						formData.append('item', JSON.stringify(jsonData));
						if(this.file || this.files.length){
							let path = env.firebase_path_prefix + 'order/quote_'+ quote_id + '/';
							formData.append('path', path);

							formData.append('instructions', this.instructions);
							this.awupload = 'uploaduprogress';
						}
						this.cartService.addToCartV2(formData, this.firebaseService).then(added => {
							this.cartService.getCart();
							this.cartService.toastService.add(this.lang.getLang('l47'), 'success');
							this.closeModal(added);
							this.cartService.setLoader(false);
						});
					}
				});
			}
		} 
		else {
			let formData = new FormData();
			formData.append('quote_item_id', this.quoteItemId);

			let path = env.firebase_path_prefix + 'order/quote_'+ this.quoteId + '/';
			formData.append('path', path);
			
			if(this.uploadedFiles.canSelectectMultiLayout){
				if(this.files.length){
					this.files.forEach(f => {
						formData.append('attachments[]', f.file);
					});
				}

				if(this.uploadedFiles._selectedItems.length){
					let itemIds = [];
					this.uploadedFiles._selectedItems.forEach(item => {
						itemIds.push(item.id);
					});
					formData.append('lns_orderattachment_files_ids', itemIds.join(','));
				}
			}
			else {
				if(this.uploadedFiles.selectedItem.id){
					formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
				}
				else {
					let file = this.file.target.files[0];
					formData.append('attachment', file);
				}
			}

			this.awupload = 'uploaduprogress';

			this.cartService.uploadArtWorkOnly(formData, this.firebaseService)
			.then(uploadResult => {
				this.closeModal("success");
			})
			.catch(error => {
				this.closeModal();
				this.cartService.toastService.add(error.message, "danger");
			});
		}
	}

	/**
	 * save the attachment to the database
	 */
	saveAttchement(item_id, firestoreLink){
		return new Promise(attach => {
			let attachmentData = {
				"item_id": item_id,
				"firesotre_link": firestoreLink,
				"firestore_task": {
					"uploadUrl_": this.firebaseService.task.task.uploadUrl_,
					"location": this.firebaseService.task.task.location_,
					"metadata_": this.firebaseService.task.task.metadata_,
					"instructions": this.instructions,
					"filename": this.firebaseService.newFilename
				},
			}
			this.cartService.setLoader(true);
			this.cartService.saveAttachment(attachmentData).then(r => {
				this.cartService.toastService.add(this.lang.getLang('l45'), 'success');
				this.closeModal();
				this.cartService.setLoader(false);
				attach(true);
			});
		});
	}

	/**
	 * generate the json request data
	 */
	getJsonData(quote_id: any = null){
		let totalLayoutCount = this.uploadedFiles._selectedItems.length + this.files.length;

		if(totalLayoutCount > 1){
			let opt = this.product.options;
			let additionalLayoutOption = opt.find(i => ("additional layout" == i.title));

			let additionalLayout = {
				option_id: additionalLayoutOption.option_id,
				option_values: []
			}

			for (let index = 0; index < totalLayoutCount; index++) {	
				if(index > 0 && index <= this.uploadedFiles.maxLayout){
					let al = additionalLayoutOption.values[index];
					additionalLayout.option_values.push(al.option_type_id);
				}
			}
			this.customOption.push(additionalLayout);
		}

		let jsonData = {
			"cartItem": {
				"sku": this.product.sku,
				"qty": this.selectedQty,
				"quote_id": quote_id,
				"product_option": {
					"extension_attributes": {
						"configurable_item_options": [],
						"custom_options": this.customOption
					}
				},
				"extension_attributes": {}
			}
		};

		let ca = this.selectedChild.custom_attributes;

		let config_option_value = ''
		ca.forEach(val => {
			if(val.attribute_code == 'sticker_shape'){
				config_option_value = val.value;
			}
		});

		let configurables = this.product.extension_attributes.configurable_product_options;

		configurables.forEach(val => {
			jsonData.cartItem.product_option.extension_attributes.configurable_item_options.push({
				"option_id": ""+val.attribute_id,
				"option_value": config_option_value
			});
		});

		return jsonData;
	}

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event){
		if(this.uploadedFiles.canSelectectMultiLayout){
			let files = event.target.files;

			let totalFiles = this.uploadedFiles._selectedItems.length + this.files.length + files.length;
			if(totalFiles <= this.uploadedFiles.maxLayout){
				for (var i = 0; i < files.length; i++) {
					let fName = files[i].name;
					let ext = fName.split('.');
					ext = ext[ext.length - 1];
					ext = ext.toLowerCase();
					if(this.config.accepted_file_type[ext]){
						let _file = files[i];
						let readableFileSize = this.filesService.humanFileSize(_file.size);

						if (!_file.type || !_file.type.startsWith('image/')) {
							this.files.push({
								image_src: "/assets/icons/document.png",
								file: _file,
								readableFileSize: readableFileSize
							});
						}
						else {
							let reader = new FileReader();
							reader.onload = () => {
								let imgSrc = reader.result;
								this.files.push({
									image_src: imgSrc,
									file: _file,
									readableFileSize: readableFileSize
								});
							};
							reader.readAsDataURL(_file);
						}
					}
				}
			}
			else {
				this.cartService.toastService.add('You can only add up to '+this.uploadedFiles.maxLayout+' layout/s.', 'danger');
			}
		}
		else {
			let fName = event.target.files[0].name;
			let ext = fName.split('.');
			ext = ext[ext.length - 1];
			ext = ext.toLowerCase();

			if(this.config.accepted_file_type[ext]){
				this.fileName = fName;
				this.file = event;
			} 
			else {
				this.fileName = null;
				this.file = null;
				let types: any = [];
				for (var key in this.config.accepted_file_type) {
				    if (this.config.accepted_file_type.hasOwnProperty(key)) {
				        types.push(key);
				    }
				}
				types = types.join(', ');
				this.cartService.toastService.add('Please upload ' + types + ' only', 'danger');
			}
		}
	}

	removeFile(index){
		this.files.splice(index, 1);
	}

	/**
	 * start upload to google fire store
	 * return promise
	 */
	upload() {
		return new Promise(resolve => {
			this.cartService.getCartId().then(quote_id => {
				this.uploadToFirebase(quote_id).then(url => {
					resolve(url);
				});
			});
		});
	}

	uploadToFirebase(quote_id) {
		return new Promise(resolve => {
			this.firebaseService
			.setFile(this.file)
			.setPath('order/quote_'+ quote_id + '/')
			.uploadToServer().then(url => {
				resolve(url);
			});
		});
	}

	getSkipStepLabel(){
		if(this.uploadedFiles.canSelectectMultiLayout){
			let sF = (this.files.length > 1 ? 's' : '');
			let sS = (this.uploadedFiles._selectedItems.length > 1 ? 's' : '')

			if(this.files.length && this.uploadedFiles._selectedItems.length){
				return "Upload new artwork"+sF+" and assign selected artwork"+sS;
			}
			else if(this.files.length && !this.uploadedFiles._selectedItems.length){
				return "Upload new artwork" + sF;
			}
			else if(!this.files.length && this.uploadedFiles._selectedItems.length){
				return "Assign selected artwork" + sS;
			}
			else {
				return 'Skip this step and upload artwork later';
			}
		}
		else {
			return 'Skip this step and upload artwork later';
		}
	}


	uploadedFiles:any = this.useUploadedFiles.uploadedFilesInit(this);
}
